import { render } from "./taxStatusCertificate.vue?vue&type=template&id=456d02d6&scoped=true"
import script from "./taxStatusCertificate.vue?vue&type=script&lang=js"
export * from "./taxStatusCertificate.vue?vue&type=script&lang=js"

import "./taxStatusCertificate.vue?vue&type=style&index=0&id=456d02d6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-456d02d6"]])

export default __exports__